import { api } from '../../api'

export const deleteBannerService = async (dataBanner: string[]) => {
  await api.delete(`/api/backoffice/banners`, { data: dataBanner })
}
